export type PersonalLibraryKind = "file" | "uploaded_image" | "generated_image" | "presentation";

export type PersonalLibraryItem = {
  id: string;
  kind: PersonalLibraryKind;
  url?: string | null;
  filename?: string | null;
  conversationId?: string | null;
  conversationTitle?: string | null;
  isGroup?: boolean;
  createdAt?: string | null;
  mimeType?: string | null;
};

export type LibraryFilter = "all" | "files" | "uploaded" | "generated" | "group";

export const getPresentationFilename = (conversationTitle?: string | null, fallback?: string | null) => {
  const title = conversationTitle?.trim().replace(/[<>:"/\\|?*\u0000-\u001F]/g, " ").replace(/\s+/g, " ").replace(/[. ]+$/, "");
  if (title) return `${title.replace(/\.pptx$/i, "")}.pptx`;
  const existing = fallback?.trim();
  return existing ? (existing.toLowerCase().endsWith(".pptx") ? existing : `${existing}.pptx`) : "presentation.pptx";
};

export const downloadUrl = async (url: string, filename: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);
    const blobUrl = URL.createObjectURL(await response.blob());
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

export const filterLibraryItems = (items: PersonalLibraryItem[], filter: LibraryFilter) => {
  if (filter === "files") return items.filter((item) => item.kind === "file");
  if (filter === "uploaded") return items.filter((item) => item.kind === "uploaded_image");
  if (filter === "generated") return items.filter((item) => item.kind === "generated_image");
  if (filter === "group") return items.filter((item) => item.isGroup);
  return items;
};

export const getLibraryItemLabel = (item: PersonalLibraryItem) => {
  if (item.kind === "presentation") return item.filename || "presentation.pptx";
  if (item.kind === "generated_image") return "generated_image.png";
  if (item.kind === "uploaded_image") return "uploaded_image.png";
  return item.filename || '';
}
